import { createAction } from '@src/redux/helpers/createAction';
import { designatePAASaga, submitTINRequestSaga } from './sagas';
import {
  DESIGNATE_PAA,
  RESET_STATE,
  SET_PHONE_NUMBER,
  SET_JOB_FUNCTIONS,
  SET_API_LIST,
  SET_SELF_ATTESTATION_DONE,
  SUBMIT_TIN_REQUEST,
  SET_API_USE_TEXT,
  SET_SELECTED_API_CODES,
} from './constants';

export const designatePAA = (req, onSuccess, onError) => {
  return createAction({
    type: DESIGNATE_PAA,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: designatePAASaga,
    },
  });
};

export const setJobFunctions = (payload) => {
  return createAction({
    type: SET_JOB_FUNCTIONS,
    payload,
  });
};

export const setApiList = (payload) => {
  return createAction({
    type: SET_API_LIST,
    payload,
  });
};

export const setApiUseText = (payload) => {
  return createAction({
    type: SET_API_USE_TEXT,
    payload,
  });
};

export const setSelectedApiCodes = (payload) => {
  return createAction({
    type: SET_SELECTED_API_CODES,
    payload,
  });
};

export const setPhoneNumber = (payload) => {
  return createAction({
    type: SET_PHONE_NUMBER,
    payload,
  });
};

export const setSelfAttestationDone = (payload) => {
  return createAction({
    type: SET_SELF_ATTESTATION_DONE,
    payload,
  });
};

export const resetState = (payload) => {
  return createAction({
    type: RESET_STATE,
    payload,
  });
};

export const submitTINRequest = (req, onSuccess, onError) => {
  return createAction({
    type: SUBMIT_TIN_REQUEST,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: submitTINRequestSaga,
    },
  });
};
